export const KEYBOARD_EVENT_KEY = {
    enter: 'Enter',
    escape: 'Escape',
    arrowUp: 'ArrowUp',
    arrowRight: 'ArrowRight',
    arrowDown: 'ArrowDown',
    arrowLeft: 'ArrowLeft',
    home: 'Home',
    end: 'End',
} as const;
